import type { AdminAuditLogListItemResponse } from "../../../types/adminTypes";
import { formatDate } from "../../../utils/DateUtils";
import AdminPillBadge from "../ui/AdminPillBadge";

type AdminAuditTableRowProps = {
  entry: AdminAuditLogListItemResponse;
};

const AdminAuditTableRow = ({ entry }: AdminAuditTableRowProps) => {
  return (
    <tr className="align-top">
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-1">
          <p className="font-semibold">{entry.adminUserEmail ?? "Unknown admin"}</p>
          <p className="text-xs text-myteengig-text-muted">{entry.adminUserId ?? "No id"}</p>
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-2">
          <AdminPillBadge>{entry.actionType}</AdminPillBadge>
          <p className="text-myteengig-text-muted">{entry.targetType}</p>
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-1">
          <p className="font-semibold">{entry.targetType}</p>
          <p className="text-myteengig-text-muted">{entry.targetId ?? "No target id"}</p>
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <p className="line-clamp-3 text-myteengig-text-muted">{entry.reason ?? "No reason recorded"}</p>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">{formatDate(entry.createdAt)}</td>
    </tr>
  );
};

export default AdminAuditTableRow;
